import { ExtendedRowData } from "./ExtendedRowData";


export class STGridEvents {
    onRowClicked?: (this: ExtendedRowData, row: ExtendedRowData, ev: MouseEvent) => void;
    onDeleteSearchCriteria?: (srcName: string) => void;
    onOpenFindResults?: (xml: string) => void;
    onIsPinned?: (pinned: boolean) => void;
    onReturnToSearch?: (searchCriteria: unknown) => void;
}
